/**
 * Client for Kyoto's standalone transcribe endpoint.
 *
 * Posts a take's audio as multipart/form-data and returns the transcript
 * segments ([{t_ms, text}]). The caller caches the result and hands it back
 * to compile() so the server skips Whisper (no double charge). See the
 * compile endpoint's optional `transcript` part.
 */
import { BASE, csrfToken, authHeader } from "../../apiClient";

export class TranscribeHttpError extends Error {
  constructor(status, body) {
    super(`transcribe failed (${status})`);
    this.status = status;
    this.body = body;
  }
}

function audioFilename(audioMime) {
  return audioMime && audioMime.includes("mp4") ? "audio.m4a" : "audio.webm";
}

export async function transcribe({ audioBlob, audioMime, signal }) {
  const fd = new FormData();
  fd.append("audio", audioBlob, audioFilename(audioMime));

  const res = await fetch(`${BASE}/workflows/transcribe`, {
    method: "POST",
    credentials: "include",
    headers: { "X-CSRFToken": csrfToken(), ...authHeader() },
    body: fd,
    signal,
  });

  let body = null;
  try { body = await res.json(); } catch (_) {}
  if (!res.ok) {
    throw new TranscribeHttpError(res.status, body);
  }
  return (body && body.transcript) || [];
}
